// ========================================
// Supabase Sync Utility
// ========================================
import { supabase } from '../lib/supabase';

/**
 * מעלה את קובץ המלאי לענן
 * 1. מעדכן את טבלת המלאי הראשי (inventory_items)
 * 2. יוצר תמונת מצב יומית (snapshots)
 * 
 * @param {Array} parsedData - הנתונים המעובדים מהאקסל
 * @param {Function} onProgress - פונקציה לעדכון התקדמות (אופציונלי)
 */
export const uploadInventoryToCloud = async (parsedData, onProgress) => {
    try {
        if (!parsedData || parsedData.length === 0) {
            throw new Error('לא נמצאו נתונים בקובץ');
        }

        const totalItems = parsedData.length;
        console.log(`מתחיל העלאה של ${totalItems} פריטים...`);

        // 1. הכנת הנתונים לפורמט של בסיס הנתונים
        const formattedItems = parsedData.map(item => ({
            sku: item.SKU,
            description: item.Description,
            physical_stock: Number(item.PhysicalStock) || 0,
            on_order: Number(item.OnOrder) || 0,
            velocity: Number(item.Velocity) || 0,
            avg_daily_sales: Number(item.AvgDailySales) || 0,
            classification: item.Classification || 'C',
            // image_url: item.ImageURL // נשמור לעתיד אם יהיה צורך
            last_updated: new Date().toISOString()
        }));

        // 2. עדכון טבלת המלאי הראשי (Batch Upsert)
        // שולחים בקבוצות של 100 כדי לא להעמיס
        const BATCH_SIZE = 100;
        for (let i = 0; i < formattedItems.length; i += BATCH_SIZE) {
            const batch = formattedItems.slice(i, i + BATCH_SIZE);

            const { error } = await supabase
                .from('inventory_items')
                .upsert(batch, { onConflict: 'sku' });

            if (error) throw error;

            if (onProgress) {
                const progress = Math.round(((i + batch.length) / totalItems) * 50); // 0-50%
                onProgress(progress);
            }
        }

        console.log('טבלת inventory_items עודכנה בהצלחה');

        // 3. יצירת תמונת מצב יומית (Snapshot)
        const today = new Date().toISOString().split('T')[0]; // YYYY-MM-DD

        // מחיקת סנאפשוט קיים להיום (אם יש) כדי למנוע כפילות באותו יום
        await supabase
            .from('snapshots')
            .delete()
            .eq('snapshot_date', today);

        // שמירת החדש
        const { error: snapshotError } = await supabase
            .from('snapshots')
            .insert({
                snapshot_date: today,
                data: formattedItems // שומרים את ה-JSON המלא
            });

        if (snapshotError) throw snapshotError;

        if (onProgress) onProgress(100);
        console.log('תמונת מצב יומית נוצרה בהצלחה');

        return { success: true, count: totalItems };

    } catch (error) {
        console.error('שגיאה בהעלאה לענן:', error);
        return { success: false, error: error.message };
    }
};
